/**
 * Conversion factor for square meters to acres.
 */
export const M2_TO_ACRES = 0.000247105;
